export const baseUrl = '/api/1.0/';

export const restApiRoutes = {
  servicesPriceList: `${baseUrl}services-price-list`
};
